<template>
  <div class="page_setting">
    <div
      class="container"
      :style="{ flexWrap: device === 'mobile' ? 'wrap' : 'nowarp' }"
    >
      <a-menu
        class="p-t-12"
        :style="{
          width: device === 'mobile' ? '100%' : '256px',
          minHeight: device === 'mobile' ? '0' : '80vh'
        }"
        :default-selected-keys="['1']"
        :mode="device === 'mobile' ? 'horizontal' : 'vertical'"
        @click="handleClick"
      >
        <a-menu-item key="1">粮食品种</a-menu-item>
        <a-menu-item key="2">储粮性质</a-menu-item>
        <a-menu-item key="3">全局设置</a-menu-item>
      </a-menu>
      <div
        style="height:100%;"
        :style="{
          width: `calc(100% - ${device === 'mobile' ? '0px' : '256px'})`
        }"
      >
        <div key="storageInfo" style="height:100%;padding: 20px 24px;" v-if="key === '1'">
          <ak-model-card
            model="storageInfo"
            title="粮食品种"
            :perPage="20"
            tableSize="small"
          />
        </div>
        <div key="storage" style="height:100%;padding: 20px 24px;" v-if="key === '2'">
          <ak-model-card
            model="storage"
            title="储粮性质"
            :perPage="20"
            tableSize="small"
          />
        </div>
        <div key="global" style="height:100%;padding: 20px 24px;" v-if="key === '3'">
          <GlobalSetting />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { notEmpty } from '../../utils/validator.js'
import { EXISTING_SECOND_LAYER_REGION } from '../../components/mapDrilling/constant.js'
import Setting from '../../components/globalSetting'
export default {
  components: {
    GlobalSetting: Setting
  },
  data () {
    return {
      key: '1',
      options: [
        {
          title: '首页相关',
          inputs: [
            {
              name: 'mapName',
              note: '地图初始地区',
              type: 'Select',
              items: this.generateRegionItems(),
              validators: []
            }
          ]
        }, {
          title: '粮仓设置',
          inputs: [
            {
              name: 'cameraLength',
              note: '摄像头最大拍摄长度（m）',
              type: 'Number',
              validators: [notEmpty()]
            }
          ]
        }
      ]
    }
  },
  methods: {
    generateRegionItems () {
      const ret = {}
      EXISTING_SECOND_LAYER_REGION.forEach((item) => {
        ret[item.adcode] = item.name
      })
      return ret
    },
    // 点击切换
    handleClick (e) {
      this.key = e.key
    }
  }
}
</script>

<style scoped lang="scss">
.page-header {
  background: #fff;
  padding: 16px 32px 0;
  border-bottom: 1px solid #e8e8e8;
  margin: -24px -24px 24px -24px;
  .breadcrumb {
    margin-bottom: 16px;
  }
  .detail {
    display: flex;
    /*margin-bottom: 16px;*/
    .avatar {
      flex: 0 1 72px;
      margin: 0 24px 8px 0;
      & > span {
        border-radius: 72px;
        display: block;
        width: 72px;
        height: 72px;
      }
    }
    .main {
      width: 100%;
      flex: 0 1 auto;
      .row {
        display: flex;
        width: 100%;
        .avatar {
          margin-bottom: 16px;
        }
      }
      .title {
        font-size: 20px;
        font-weight: 500;
        font-size: 20px;
        line-height: 28px;
        font-weight: 500;
        color: rgba(0, 0, 0, 0.85);
        margin-bottom: 16px;
        flex: auto;
      }
      .logo {
        width: 28px;
        height: 28px;
        border-radius: 4px;
        margin-right: 16px;
      }
      .content,
      .headerContent {
        flex: auto;
        color: rgba(0, 0, 0, 0.45);
        line-height: 22px;
        .link {
          margin-top: 16px;
          line-height: 24px;
          a {
            font-size: 14px;
            margin-right: 32px;
          }
        }
      }
      .extra {
        flex: 0 1 auto;
        margin-left: 88px;
        min-width: 242px;
        text-align: right;
      }
      .action {
        margin-left: 56px;
        min-width: 266px;
        flex: 0 1 auto;
        text-align: right;
        &:empty {
          display: none;
        }
      }
    }
  }
}
.mobile .page-header {
  .main {
    .row {
      flex-wrap: wrap;
      .avatar {
        flex: 0 1 25%;
        margin: 0 2% 8px 0;
      }
      .content,
      .headerContent {
        flex: 0 1 70%;
        .link {
          margin-top: 16px;
          line-height: 24px;
          a {
            font-size: 14px;
            margin-right: 10px;
          }
        }
      }
      .extra {
        flex: 1 1 auto;
        margin-left: 0;
        min-width: 0;
        text-align: right;
      }
      .action {
        margin-left: unset;
        min-width: 266px;
        flex: 0 1 auto;
        text-align: left;
        margin-bottom: 12px;
        &:empty {
          display: none;
        }
      }
    }
  }
}
.container {
  width: 100%;
  background: #ffffff;
  display: flex;
  align-items: stretch;
  .text-primary {
    color: #202224;
  }
  .text-black {
    color: #363b45;
  }
  .text-gray {
    color: #808690;
  }
  .ant-btn {
    width: 54px !important;
    height: 32px !important;
    padding: 0 !important;
  }
  .setting-time-input {
    width: 75px;
    height: 32px;
    background: #ffffff;
    border: 1px solid #dbdde1;
    border-radius: 6px;
  }
  .ant-upload {
    img {
      width: 100%;
      height: 100%;
    }
  }
}
</style>
